import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const handleInputChange = (idSelector) => (choice) => {
    if(choice === 0){
        choice = "brak"
    }
    const selector = document.getElementById(idSelector);
    if (selector) {
        selector.value = String(choice);
    }
}

ReactDOM.render(<App 
    base_url='' 
    initialSelection={{
        arm: 0,
        insert: 0,
        color: 0
    }}
    hanldeSetColorVariation={handleInputChange("kolor")}
    handleSetArmVariation={handleInputChange("ramie")}
    handleSetInsertVariation={handleInputChange("wypelnienie")}
    />, document.getElementById('configurator'));

serviceWorker.unregister();